import { getRequest } from '../services/requestHandler';
import { PlayerRegionLookup } from '../models';

export const getPlayerRegionLookups = async () => {
  const url = 'player/getPlayerRegionLookups?activeOnly=true&useCache=true';
  const response = await getRequest<PlayerRegionLookup>('GetPlayerRegionLookups', url);
  return response;
};
